import { ReactElement, ReactNode, useState } from 'react'
import { Visibility, VisibilityOff } from '../../icons'

import cn from 'classnames'
import { InputField } from './InputFields'

type PasswordWrapperProps = {
  imgBefore?: ReactElement | string
  imgAfter?: ReactElement | string
  onClick?: () => void
  children: ReactNode
  isFirst?: boolean
  className?: string
  hasError?: boolean
  theme?: 'default' | 'grey'
  hasOverflow?: boolean
  isNew?: boolean
}

export const PasswordWrapper = ({
  children,
  imgAfter,
  onClick,
  className,
  hasError,
  isNew,
}: PasswordWrapperProps) => {
  return (
    <div
      className={cn(
        'w-full',
        isNew
          ? 'bg-white flex rounded-lg gap-1 items-center relative'
          : 'flex flex-col justify-self-start item-center relative',
        hasError && 'border-2 border-red-500',
        'lg:bg-white',
        className,
      )}
      onClick={onClick}
    >
      {children}
      <div className='pr-4 lg:pr-5 absolute top-2.5 right-0'>{imgAfter}</div>
    </div>
  )
}

export const PasswordField = (props) => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    setIsVisible(!isVisible)
  }

  const Icon = isVisible ? Visibility : VisibilityOff

  return (
    <PasswordWrapper
      hasError={props.error}
      isNew={props.isNew}
      imgAfter={
        <button
          type='button'
          className='flex opacity-50'
          onClick={toggleVisibility}
        >
          <Icon width={24} height={24} className='opacity-70' />
        </button>
      }
    >
      <InputField
        password={props.password}
        repeatPassword={props.repeatPassword}
        register={props.register}
        required={props.required}
        validate={props.validate}
        id={props.id}
        label={props.label}
        placeholder={props.placeholder}
        className={props.className}
        errors={props.errors}
        errorMessage={props.errorMessage}
        type={isVisible ? 'text' : 'password'}
      />
    </PasswordWrapper>
  )
}
